import { selectAuthenticatedUser } from '@app/store';
import { useAppSelector } from '@app/store/hooks';
import { Permission, checkPermissions } from '@tickeat/permissions';

export const useCheckPermissions = () => {
  const user = useAppSelector(selectAuthenticatedUser);

  return (permissions: Permission[]) => {
    if (!user) {
      return false;
    }

    return checkPermissions(user, permissions);
  };
};
